var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.flag)?_c('pageCard',{attrs:{"pagename":"产品中心","desc":"CENTER OF PRODUTION","bg":"cp-top.png","mb":"首页>产品中心"}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }